import { epgChannelRequest } from '@/types/epg/epgChannelRequest'
import { create } from 'zustand'

interface ChannelState {
    channelsParams: epgChannelRequest[]
    shouldFetch: boolean
    direction: 'up' | 'down' | 'firstRender' | null

    setChannelsParams: (channels: epgChannelRequest | []) => void
    setShouldFetch: (value: boolean) => void
    setDirection: (direction: 'up' | 'down' | 'firstRender' | null) => void
    resetEpgCacheStore: () => void
}

export const useEpgCacheStore = create<ChannelState>((set, get) => ({
    channelsParams: [],
    shouldFetch: false,
    direction: null,

    setChannelsParams: (channel: epgChannelRequest | []) => {
        let newChannels: epgChannelRequest[]
        const { channelsParams } = get()

        if (Array.isArray(channel))
            return set(() => ({
                channelsParams: [],
            }))

        const exist = channelsParams.find(
            (item) => item.channelId === channel.channelId
        )
        if (
            exist?.channelId === channel.channelId &&
            (exist?.start === channel.start || exist?.end === channel.end)
        )
            return
        if (!exist) newChannels = [...channelsParams, channel]
        else
            newChannels = channelsParams.map((item) => {
                if (item.channelId === exist.channelId) {
                    if (exist.start) item.start = channel.start
                    else if (exist.end) item.end = channel.end
                }
                return item
            })

        set(() => ({
            channelsParams: newChannels,
        }))
    },
    setShouldFetch: (value: boolean) =>
        set({
            shouldFetch: value,
        }),
    setDirection: (direction: 'up' | 'down' | 'firstRender' | null) =>
        set({
            direction,
        }),
    resetEpgCacheStore: () =>
        set({
            channelsParams: [],
            shouldFetch: false,
            direction: null,
        }),
}))
